import {ClassName} from '#/utils/utils';
import {FunctionComponent} from 'react';

type TileFilterButtonProps<T extends {}> = {
  filter: T;
  selectedFilters: T[];
  removeFilter: (value: T) => void;
  setFilter: (value: T) => void;
  title: string;
  IconComponent: FunctionComponent<ClassName>;
  iconColorClassName: string;
  primaryTextColor: string;
  bgColor: string;
} & ClassName;

export const TileFilterButton = <T extends {}>(props: TileFilterButtonProps<T>): JSX.Element => {
  const {
    className = '',
    selectedFilters,
    removeFilter,
    setFilter,
    filter,
    title,
    IconComponent,
    iconColorClassName,
    primaryTextColor,
    bgColor,
    ...rest
  } = props;

  const isSelected = selectedFilters.includes(filter);
  const colorClassName = isSelected ? `${bgColor} ${primaryTextColor}` : 'bg-grayblue text-white';

  const onClick = () => {
    if (selectedFilters.includes(filter)) {
      removeFilter(filter);
      return;
    }
    setFilter(filter);
  };

  return (
    <button
      className={`flex items-center gap-1 ${colorClassName} border border-transparent pl-1 pr-2 py-0.5 rounded-full whitespace-nowrap group hover:opacity-70 ${className}`}
      onClick={onClick}
      {...rest}
    >
      <IconComponent className={`${isSelected ? iconColorClassName : 'stroke-transparent fill-white'} w-3 h-3`} />
      <span className='text-xs'>{title}</span>
    </button>
  );
};
